import React from "react";
import { Container, Col, Spinner, Card } from "react-bootstrap";

import { useCmsHook } from "../helpers/cmsHook";

function Confirmation() {
  const { cmsInstance } = useCmsHook();
  return (
    <>
      {!cmsInstance ? (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="d-flex flex-row justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div>
          <Container className="d-flex flex-row justify-content-center py-5">
            <Col lg={10}>
              <Card className="w-100 confirmation-card px-2">
                <Card.Body>
                  {cmsInstance &&
                    cmsInstance.showRichText("cmsContent.confirmationPage")}
                </Card.Body>
              </Card>
            </Col>
          </Container>
        </div>
      )}
    </>
  );
}

export default Confirmation;
